import { shopDefaults } from './defaultStates';
import ActionTypes from '../constants/actionTypes';
import SHOP_PARAMETER_CODES from '../constants/shopParameterCodes';

export default function(state = shopDefaults, action) {
  switch (action.type) {
    case ActionTypes.UPDATE[SHOP_PARAMETER_CODES.PARAMETERS]:
      if (!action.payload.customerType || action.payload.customerType === '') {
        action.payload.customerType = 'ANON';
      }
      if (!action.payload.locale || action.payload.locale === '') {
        action.payload.locale = 'de-DE';
      }
      if (
        !action.payload.partnerServiceNumber ||
        action.payload.partnerServiceNumber === ''
      ) {
        action.payload.partnerServiceNumber = '+49 89 8391-9900';
      }

      var mergedData = Object.assign({}, state.data, action.payload);
      return {
        data: mergedData
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_shop_parameters.js